module.exports = __webpack_public_path__ + "static/media/classicalScheme@2x.236cd455.png";